export default __webpack_public_path__ + "static/media/calendar_black.549d597d.svg";